import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "search-container"
};
import { ChevronRightDoubleIcon } from 'tdesign-icons-vue-next';
/** 组合式api */
import { ref, reactive, watch } from 'vue';
/** 接口 */
import { getSchoolList, getDictItem } from '@/api/index-jiao.js';
import { deepClone } from '@/utils/index';
import { env_name } from '@/util/util.js';
export default {
  __name: 'topSearch',
  emits: ['handleSearch'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;

    /** 初始化相关_方法 */
    var getSchoolListMtd = function getSchoolListMtd() {
      var accessInfo = JSON.parse(localStorage.getItem('accessInfo'));
      getSchoolList({
        userId: accessInfo.content.user_id
      }).then(function (res) {
        if (res.data.code === 0) {
          schoolOptions.value = res.data.data || [];
        }
      });
    };
    var getDictItemMtd = function getDictItemMtd(type, option) {
      getDictItem(type).then(function (res) {
        if (res.data.code === 0) {
          option.value = res.data.data || [];
        }
      });
    };

    /** 初始化相关 */
    var form = reactive({
      schoolIds: null,
      // 学校id
      subjectDictItemCode: null,
      // 学科id
      classType: null,
      // 班级类型
      subjectDictItemName: '',
      // 学科名称
      classGrade: null,
      // 年级
      showGradeName: '',
      // 年级文本_仅供列表展示用
      startDate: '',
      // 开始时间
      endDate: '' // 结束时间
    });
    var schoolOptions = ref([]); // 学校下拉
    var subjectOptions = ref([]); // 学科下拉
    var gradeOptions = ref([]); // 年级下拉
    var classTypeOptions = ref([
    // 班级类型下拉
    {
      value: 0,
      label: '行政班'
    }, {
      value: 1,
      label: '走班'
    }]);
    getSchoolListMtd(); // 获取学校下拉
    getDictItemMtd('subject', subjectOptions); // 获取学科下拉
    getDictItemMtd('grade', gradeOptions); // 获取年级下拉

    /** watch监听 */
    watch([function () {
      return form.startDate;
    }, function () {
      return form.endDate;
    }], function (nval) {
      if (nval[0] && nval[1]) {
        var timeOne = new Date(nval[0]).getTime();
        var timeTwo = new Date(nval[1]).getTime();
        if (timeOne > timeTwo) {
          form.startDate = nval[1];
          form.endDate = nval[0];
        }
      }
    });

    /** 事件相关 */
    /**
     * 重置
     */
    var handleReset = function handleReset() {
      Object.keys(form).forEach(function (key) {
        form[key] = null;
      });
      handleSearch();
    };

    /**
     * 查询
     */
    var handleSearch = function handleSearch() {
      if (form.subjectDictItemCode) {
        form.subjectDictItemName = subjectOptions.value.find(function (i) {
          return i.code === form.subjectDictItemCode;
        }).displayName;
      } else {
        form.subjectDictItemName = '';
      }
      if (form.classGrade) form.showGradeName = gradeOptions.value.find(function (i) {
        return i.code === form.classGrade;
      }).displayName;
      var obj = deepClone(form);
      if (form.schoolIds) {
        obj.schoolIds = [form.schoolIds];
      }
      emit('handleSearch', obj);
    };
    handleSearch();
    // 查看更多
    var toClassReport = function toClassReport() {
      var commonName = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : '//web.zhixuehuijiao.cn';
      window.open("".concat(commonName, "/classReports?classReports=%2Freport"));
    };
    return function (_ctx, _cache) {
      var _component_t_select = _resolveComponent("t-select");
      var _component_t_form_item = _resolveComponent("t-form-item");
      var _component_t_date_picker = _resolveComponent("t-date-picker");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_form = _resolveComponent("t-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_form, {
        data: form,
        layout: "inline"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_form_item, {
            label: "学校",
            "label-width": "44px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                class: "w-140",
                modelValue: form.schoolIds,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return form.schoolIds = $event;
                }),
                options: schoolOptions.value,
                keys: {
                  label: 'schoolName',
                  value: 'schoolId'
                },
                clearable: "",
                onChange: handleSearch
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }), _createVNode(_component_t_form_item, {
            label: "学科",
            "label-width": "44px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                class: "w-140",
                modelValue: form.subjectDictItemCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return form.subjectDictItemCode = $event;
                }),
                options: subjectOptions.value,
                keys: {
                  label: 'displayName',
                  value: 'code'
                },
                clearable: "",
                onChange: handleSearch
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }), _createVNode(_component_t_form_item, {
            label: "班级类型",
            "label-width": "72px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: form.classType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return form.classType = $event;
                }),
                class: "w-140",
                options: classTypeOptions.value,
                clearable: "",
                onChange: handleSearch
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }), _withDirectives(_createVNode(_component_t_form_item, {
            label: "年级",
            "label-width": "44px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                class: "w-140",
                modelValue: form.classGrade,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return form.classGrade = $event;
                }),
                options: gradeOptions.value,
                keys: {
                  label: 'displayName',
                  value: 'code'
                },
                clearable: "",
                onChange: handleSearch
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }, 512), [[_vShow, form.classType !== 1]]), _createVNode(_component_t_form_item, {
            label: "起止时间",
            "label-width": "72px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_date_picker, {
                modelValue: form.startDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                  return form.startDate = $event;
                }),
                class: "w-140",
                placeholder: "开始时间",
                format: "YYYY-MM-DD",
                clearable: ""
              }, null, 8, ["modelValue"]), _cache[6] || (_cache[6] = _createElementVNode("div", {
                class: "mar-4"
              }, "~", -1)), _createVNode(_component_t_date_picker, {
                modelValue: form.endDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                  return form.endDate = $event;
                }),
                class: "w-140",
                placeholder: "结束时间",
                format: "YYYY-MM-DD",
                clearable: ""
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_t_form_item, {
            "label-width": "0"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_t_button, {
                theme: "default",
                class: "mar-16",
                onClick: handleReset
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[7] || (_cache[7] = [_createTextVNode("重置", -1)]));
                }),
                _: 1
              }), _createVNode(_component_t_button, {
                theme: "primary",
                onClick: handleSearch
              }, {
                default: _withCtx(function () {
                  return _toConsumableArray(_cache[8] || (_cache[8] = [_createTextVNode("查询", -1)]));
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", {
        class: "look-more",
        onClick: toClassReport
      }, [_cache[9] || (_cache[9] = _createTextVNode(" 查看更多 ", -1)), _createVNode(_unref(ChevronRightDoubleIcon))])]);
    };
  }
};